import { UpdateSalaryRangeDocument, UpdateSalaryRangeMutation } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useUpdateSalaryRange = () => {
  const [mutate] = useMutation(UpdateSalaryRangeDocument, {
    extractorFn: (data: UpdateSalaryRangeMutation) =>
      data.jobCatalogMutations.updateJobcatalogSalaryRange,
  })

  const updateSalaryRange = (
    id: number,
    amountType: string,
    currency: string,
    legalEntitiesIds: number[],
    maxRange: number,
    minRange: number,
    salaryFrequency: string
  ) => {
    return mutate({
      variables: {
        id,
        amountType,
        currency,
        legalEntitiesIds,
        maxRange,
        minRange,
        salaryFrequency,
      },
    })
  }

  return updateSalaryRange
}

export default useUpdateSalaryRange
